// Recovered compiled webpack factory 1262. Edit this function expression; run npm run build.
(e, t, r) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(12115),
    i = n.useLayoutEffect,
    o = n.useEffect;
  function a(e) {
    let { headManager: t, reduceComponentsToState: r } = e;
    function a() {
      if (t && t.mountedInstances) {
        let i = n.Children.toArray(Array.from(t.mountedInstances).filter(Boolean));
        t.updateHead(r(i, e));
      }
    }
    return (
      i(() => {
        var r;
        return (
          null == t || null == (r = t.mountedInstances) || r.add(e.children),
          () => {
            var r;
            null == t || null == (r = t.mountedInstances) || r.delete(e.children);
          }
        );
      }),
      i(
        () => (
          t && (t._pendingUpdate = a),
          () => {
            t && (t._pendingUpdate = a);
          }
        ),
      ),
      o(
        () => (
          t && t._pendingUpdate && (t._pendingUpdate(), (t._pendingUpdate = null)),
          () => {
            t && t._pendingUpdate && (t._pendingUpdate(), (t._pendingUpdate = null));
          }
        ),
      ),
      null
    );
  }
}
